"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tinyEmitter = _interopRequireDefault(require("tiny-emitter"));
var _default = exports.default = new _tinyEmitter.default();